module.exports = __webpack_public_path__ + "img/10.fb799900.png";